import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Services from '../views/Services.vue'
import Blogs from '../views/Blogs.vue'
import BlogDetail from '../views/BlogDetail.vue'
import SuccessStories from '../views/SuccessStories.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import TermsConditions from '../views/TermsConditions.vue'
import Article from '@/views/Article.vue'
import Podcast from '@/views/Podcast.vue'
import Login from '@/views/Login.vue'
import Espace from '@/views/dashboard/Espace.vue'
import BlogManagment from '@/views/dashboard/BlogManagment.vue'
import ListArticle from '@/views/dashboard/ListArticle.vue'
import PodcastManagement from '@/views/dashboard/PodcastManagement.vue'
import ListPodcast from '@/views/dashboard/ListPodcast.vue'
import ProfilManagement from '@/views/dashboard/ProfilManagement.vue'
import AddBlogeur from '@/views/dashboard/AddBlogeur.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/services',
    name: 'services',
    component: Services
  },
  {
    path: '/blogs',
    name: 'blogs',
    component: Blogs
  },
  {
    path: '/blog-detail',
    name: 'blogDetail',
    component: BlogDetail
  },
  {
    path: "/blogs/articles/:id/:slug",
    name: "articles",
    component: Article,
  },
  
  {
    path: '/podcasts',
    name: 'podcasts',
    component: Podcast
  },
  {
    path: '/success-stories',
    name: 'successStories',
    component: SuccessStories
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-conditions',
    name: 'termsConditions',
    component: TermsConditions
  },

  // Routes protégées par authentification
  {
    path: '/dashboard/espace',
    name: 'espace',
    component: Espace,
 //   meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/add-article',
    name: 'add-article',
    component: BlogManagment,
  //  meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/manage-article',
    name: 'manage-article',
    component: ListArticle,
  //  meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/add-podcast',
    name: 'add-podcast',
    component: PodcastManagement,
 //   meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/manage-podcast',
    name: 'manage-commentaire',
    component: ListPodcast,
 //   meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/manage-profil',
    name: 'manage-profil',
    component: ProfilManagement,
  //  meta: { requiresAuth: true }
  },

  {
    path: '/dashboard/add-blogger',
    name: 'add-blogger',
    component: AddBlogeur,
  //  meta: { requiresAuth: true }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


export default router
